import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { useNavigationType } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useStore } from "../../store";
import Title from "../../components/Title";
import Handler, { countryLabel } from "./Modules/Handler";
import PopularTable from "./Modules/PopularTable";
import { Wrap, SummaryBar, TableFooterSpace } from "./styles";
import { matchTypeLabel } from "./keywordParams";

dayjs.extend(utc);

const utcDay = (iso: string) => {
  if (!iso) return "";
  return dayjs(iso).utc().format("YYYY-MM-DD");
};

/**
 * Keywords — 국가별 인기 해시태그 순위. `/keywords`
 * 필터(Handler) + 집계 요약(SummaryBar) + 키워드 표(PopularTable).
 * 키워드를 누르면 `/keywords/:keyword` 로 드릴다운한다.
 */
const Keywords = () => {
  const {
    KeywordsStore: { popular, sortBy, matchType, fetchPopular },
  } = useStore();
  const navigationType = useNavigationType();

  useEffect(() => {
    // 드릴다운/디테일에서 뒤로 돌아온 경우(POP)에는 싱글톤 store 의 결과를 그대로
    // 보여준다. 다시 조회하면 사용자가 펼쳐 본 위치와 스크롤을 잃는다.
    // 단, 드릴다운에서 정렬을 바꿨거나 검색으로 키워드 유형이 바뀌었으면 결과가
    // 낡았으므로 다시 조회한다.
    const isReturn =
      navigationType === "POP" &&
      popular.fetched &&
      popular.sortBy === sortBy &&
      popular.matchType === matchType;
    if (isReturn) return;
    fetchPopular();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrap>
      <Title label="Keywords" isDivider />
      <Handler />
      {popular.fetched && !popular.loading && (
        <SummaryBar>
          <span>
            Country <strong>{countryLabel(popular.country)}</strong>
          </span>
          <span>
            Keyword type <strong>{matchTypeLabel(popular.matchType)}</strong>
          </span>
          <span>
            Published{" "}
            <strong>
              {utcDay(popular.startedAt)} ~ {utcDay(popular.endedAt)}
            </strong>{" "}
            (UTC)
          </span>
          <span>
            Scanned templates{" "}
            <strong>{popular.scannedTemplates.toLocaleString()}</strong>
          </span>
          <span>
            Keywords <strong>{popular.keywords.length}</strong>
          </span>
        </SummaryBar>
      )}
      <PopularTable />
      <TableFooterSpace />
    </Wrap>
  );
};

export default observer(Keywords);
